import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";

export default function PolitiqueConfidentialite() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Politique de Confidentialité | Dépan'Volets Strasbourg"
        description="Politique de confidentialité Dépan'Volets Strasbourg. Collecte et protection des données personnelles conformément au RGPD. 82 Rue de Heidenberg, 67200 Strasbourg."
        path="/politique-confidentialite"
        type="website"
        robots="noindex, follow"
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Politique de confidentialité" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Politique de confidentialité" }]} />
      <main>
        <header className="bg-[#143A66] text-white py-20 md:py-24">
          <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">Politique de confidentialité</h1>
            <p className="text-white/80 text-base md:text-lg">Dernière mise à jour : 29 mai 2026</p>
          </div>
        </header>

        <DiagnosticVideo />

        <section className="bg-white py-14 md:py-20">
          <div className="max-w-4xl mx-auto px-4 md:px-8">
            <article className="space-y-12 text-brand-text leading-relaxed">
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">1. Qui sommes-nous ?</h2>
                <p><strong>Dépan'Volets</strong> est une entreprise locale spécialisée dans la <a href="/reparation-volet-roulant" className="text-brand-blue hover:underline">réparation</a>, la <a href="/motorisation-somfy" className="text-brand-blue hover:underline">motorisation</a> et la pose de volets roulants à Strasbourg et dans le Bas-Rhin. Notre atelier : 82 Rue de Heidenberg, 67200 Strasbourg.</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">2. Données collectées</h2>
                <p className="mb-4">Nous collectons uniquement les données nécessaires à vos demandes :</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Identité :</strong> nom et prénom</li>
                  <li><strong>Coordonnées :</strong> adresse, téléphone, e-mail</li>
                  <li><strong>Demande :</strong> nature du projet et description de la panne</li>
                  <li><strong>Localisation :</strong> ville d'intervention</li>
                </ul>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">3. Finalités du traitement</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Vous contacter suite à votre demande de <a href="/tarifs" className="text-brand-blue hover:underline">devis gratuit</a></li>
                  <li>Planifier et réaliser l'intervention</li>
                  <li>Assurer le suivi de garantie</li>
                </ul>
                <p className="mt-4"><strong>Base légale :</strong> exécution d'un contrat (art. 6.1.b RGPD).</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">4. Durée de conservation</h2>
                <p>Vos données sont conservées 3 ans après la fin de la relation commerciale, conformément aux obligations légales comptables.</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">5. Destinataires</h2>
                <p>Seuls nos techniciens et collaborateurs internes ont accès à vos données. Elles ne sont ni vendues, ni transmises à des tiers à des fins commerciales.</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">6. Vos droits</h2>
                <p className="mb-4">Conformément au RGPD, vous disposez des droits d'accès, de rectification, d'effacement, de limitation, de portabilité et d'opposition.</p>
                <p>Pour exercer ces droits : <a href="mailto:contact@depanvolets-strasbourg.fr" className="text-brand-blue hover:underline">contact@depanvolets-strasbourg.fr</a> — 82 Rue de Heidenberg, 67200 Strasbourg.</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">7. Cookies</h2>
                <p>Uniquement des cookies techniques nécessaires au fonctionnement. Aucun cookie de traçage sans consentement préalable.</p>
              </div>
              <div>
                <h2 className="text-brand-blue text-xl font-bold mb-4">8. Réclamation CNIL</h2>
                <p>Vous pouvez introduire une réclamation auprès de la <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer nofollow" className="text-brand-blue hover:underline">CNIL</a> si vous estimez que vos droits ne sont pas respectés.</p>
              </div>
            </article>
          </div>
        </section>
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}